import * as React from 'react'

const SvgTextAlignRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 3.75h8.75V5H3.75V3.75zm2.5 3.75h6.25v1.25H6.25V7.5zm-2.5 3.75h8.75v1.25H3.75v-1.25zM6.25 15h6.25v1.25H6.25V15zM15 2.5h1.25v15H15v-15z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextAlignRightIcon
